const noPolling: boolean = process.env.REACT_APP_NO_POLLING === 'true'

export const emptyArr: never[] = []
export const DEFAULT_POLLING_INTERVAL = noPolling ? 0 : 5000
